export * from './files.service';
import { FilesApiService } from './files.service';
export const APIS = [FilesApiService];
